import { useLingui } from '@lingui/react/macro';
import { Duration } from 'date-fns';
import { useCallback } from 'react';

import { useCurrentLocale } from '#features/i18n';

const formatDuration = (
  duration: Duration,
  { hourDelimiter, minuteDelimiter }: { hourDelimiter: string; minuteDelimiter: string }
): string => {
  const hours = duration.hours && duration?.hours > 0 ? duration.hours : 0;
  const minutes = duration.minutes && duration.minutes > 0 ? duration.minutes : 0;

  return `${hours ? `${hours}${hourDelimiter} ` : ''}${minutes ? `${minutes}${minuteDelimiter}` : ''}`;
};

export const useFormatDuration = () => {
  // Язык читается через `useCurrentLocale`, а не через переключатель языка: тот тянет за собой
  // дерево маршрутов, и хук, который рисуется по всему приложению, ронял страницу настроек при
  // гонке инвалидации роутера. Проверка на это стоит в тестах i18n.
  const currentLocale = useCurrentLocale();
  const { t } = useLingui();

  return useCallback(
    (duration: Duration) =>
      formatDuration(duration, {
        hourDelimiter: t`hourShort`,
        minuteDelimiter: t`minuteShort`,
      }),
    // Настоящая зависимость это `t`: подписи «ч» и «мин» берутся из неё, и меняется она же.
    // Раньше здесь стоял один только язык, и пересчёт держался на том, что они меняются
    // одновременно — на совпадении, а не на связи.
    //
    // Язык остаётся в списке намеренно, хотя сам в форматирование не уходит: числа тут не
    // локализуются. Он держит хук привязанным к `useCurrentLocale`, чего требует проверка в
    // features/i18n — читать язык через переключатель нельзя, тот тянет дерево маршрутов и
    // ронял страницу настроек при гонке инвалидации роутера.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, currentLocale]
  );
};
